import React from "react";
import { useLocation } from "react-router-dom";

interface DataTableMobileProps {
  rows: Array<{
    names: string;
    identityDocument: string;
    relationshipName: string;
    familyNumber: string;
    insureFrom: string;
    antiquity: string;
  }>;
  columns?: any;
  onRowClick?: (row: any) => void;
}

const DataTableMobile: React.FC<DataTableMobileProps> = ({ rows, columns, onRowClick }) => {
  const location = useLocation();
  const payload = location.state?.payload;

  return (
    <div className="tablas-movil composicion">
      {rows.map((row, index) => (
        <div key={index} className="tablas-movil-box solicitud">
          <div className="tablas-movil-title is-cfamiliar">
            <div className="perfil-subtitle">{row.names}</div>
            <div>{row.identityDocument}</div>
          </div>
          <div className="tablas-movil-content">
            {columns.map((column: any, index: number) =>
              (column.visible && 
                (column.tipo === "button" ? (
                <div key={index} className={"tablas-movil-box-row" + (column.color ? " color" : "")}>
                  <div className="tablas-movil-box-txt">{column.label}</div>
                  <button className="button is-tablamovil w-button"  onClick={() => onRowClick && onRowClick(row)}>Ver más</button>
                </div>
              ) : (
                <div key={index} className={"tablas-movil-box-row" + (column.color ? " color" : "")}>
                  <div className="tablas-movil-box-txt">{column.label}</div>
                  <div className="tablas-movil-box-txt right">
                    {column.tipo === 'status' && <span className={"circle-" + (row[column.key as keyof typeof row] === 'Vigente' ? 'green' : 'red')}></span>}
                    {row[column.key as keyof typeof row]}</div>
                </div>
              )))
              
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DataTableMobile;